import { Broadcast, BroadcastSortingField } from 'videoservice-openapi-react';
import { ITableColumn } from 'shared/ui/table';

export const columns: ITableColumn<keyof Broadcast, BroadcastSortingField>[] = [
  {
    key: 'enabled',
    caption: 'Статус',
    width: '74px',
    sortingValue: BroadcastSortingField.ENABLED,
  },
  {
    key: 'startDate',
    caption: 'Дата и время',
    width: '156px',
    sortingValue: BroadcastSortingField.STARTDATE,
  },
  {
    key: 'id',
    caption: 'ID',
    width: '206px',
    sortingValue: BroadcastSortingField.ID,
  },
  {
    key: 'providerType',
    caption: 'Провайдер',
    width: '140px',
    sortingValue: BroadcastSortingField.PROVIDERTYPE,
  },
  {
    key: 'sportId',
    caption: 'Вид спорта',
    width: '180px',
    sortingValue: BroadcastSortingField.SPORTID,
  },
  {
    key: 'broadcastTournament',
    caption: 'Чемпионат',
    width: '200px',
    sortingValue: BroadcastSortingField.TOURNAMENTNAME,
  },
  {
    key: 'streamId',
    caption: 'Трансляция',
    width: '100%',
    sortingValue: BroadcastSortingField.STREAMID,
  },
  {
    key: 'mappings',
    caption: 'Привязанные события (ID)',
    width: '100%',
  },
];
